<template>
    <Modal :id="id" :open="show" customSizeWid="width:700px;margin: 0 auto;padding-top:10px" :FooterDefault="false" :ClassBG="true" customModalBody="min-height: calc(100vh - 73rem);" :customModalMain="'z-index:1051'">
        <template v-slot:header>
            <h6 class="modal-title">Enviar Alerta</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
            </button>
        </template>
        <template v-slot:body>
            <Form ref="Form_DisparoAlerta" @submit="submit_Form_DisparoAlerta">
                <div class="row mt-3">
                    <div class="col">
                        <label class="form-label">Modelo De E-mail</label>
                        <vue-select v-model="modelo_selected" :options="modelos" :label-by="(e) => (e.nmModelo)"
                                    placeholder="Digite e selecione o nome do modelo" searchable search-placeholder="Pesquise"
                                    close-on-select clear-on-select :min="1" class="form-control ms-2 shadow-v2">
                        </vue-select>
                    </div>
                </div>
            </Form>
        </template>

        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                    Fechar
                </button>
                <button type="button" class="btn btn-red-v2" @click="submit_Form_DisparoAlerta">
                    <i class="fas fa-paper-plane pe-2"></i>
                    Enviar Alerta
                </button>
            </div>
        </template>

    </Modal>
</template>


<script>

    import axios from "axios";
    import Modal from "@/components/App/Modal.vue";
    import VueNextSelect from "vue-next-select";
    import "vue-next-select/dist/index.min.css";

    export default {
        name: "DisparoAlerta",
        components: {
            "vue-select": VueNextSelect,
            Modal
        },
        props: {
            id: {
                type: String,
                default: 'disparo_alerta'
            },
            show: {
                type: Boolean,
                default: false
            },
            idEvento: {
                type: Number,
                default: 0
            },
            idInscricao: {
                type: Number,
                default: 0
            },
            idParticipante: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                modelos: [],
                modelo_selected: { idModeloEmail: 0 },
                DisparoAlertaCrud: {
                    idOcorrencia: 0,
                    dsMotivo: ''
                },

                showErrorMessage: false,

            };
        },
        methods: {
            getModelosEmail() {
                let $this = this;
                axios.get(
                    process.env.VUE_APP_ROOT_EVENTOS_API +
                    "/ModeloEmail/Get?" + '&idEvento=' + $this.idEvento,
                    { headers: $this.$api.getTokenEventos(), })
                    .then((response) => {
                        $this.modelos = response.data.data;
                    });
            },
            zerarInfoCrud() {
                this.OcorrenciaFinalizarCrud = {
                    idOcorrencia: 0,
                    dsMotivo: ''
                }
            },
            submit_Form_DisparoAlerta() {
                //let $this = this;
                this.$toast.show('alert', 'Desabilitado.', true);
                //$this.OcorrenciaFinalizarCrud.idOcorrencia = $this.idOcorrencia;

                //$this.$refs.Form_DisparoAlerta.validate()
                //    .then(isValid => {
                //        if (isValid.valid) {
                //            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/PostFinalizarTicket', $this.OcorrenciaFinalizarCrud, { headers: $this.$api.getTokenComercial() })
                //                .then(function (response) {
                //                    $this.$emit('fechou_ticket');
                //                    $this.zerarInfoCrud();
                //                })
                //                .catch(function (error) {
                //                    var msg = 'Ocorreu um erro inesperado';
                //                    if (error.response) {
                //                        if (error.response.data.erros != '') {
                //                            msg = error.response.data.errors[0];
                //                        } else {
                //                            msg = error.response.data.msg;
                //                        }
                //                    }

                //                    $this.$toast.show('alert', msg, true);
                //                });
                //            $this.showErrorMessage = false;
                //        } else {
                //            throw new Error();
                //        }
                //    })
                //    .catch(error => {
                //        var msg = 'Por favor, preencha todos os campos obrigatorios';
                //        if (error.response) {
                //            if (error.response.data.erros != '') {
                //                msg = error.response.data.errors[0];
                //            } else {
                //                msg = error.response.data.msg;
                //            }
                //        }
                //        $this.showErrorMessage = true;
                //        $this.$toast.show('alert', msg, true);
                //    });

            },
        },
        mounted() { },
        watch: {
            show(n, o) {
                if (n) {
                    this.getModelosEmail();
                }
            },
        },
    };

</script>


<style scoped lang="scss">
</style>